import { Link } from "@material-ui/core";
import { useState, useEffect, useReducer } from "react";
import AsideNewFeed from "../../components/AsideNewFeed";
// import { getStepContent } from "./addCreditzfunctions";
import AddContributers from "./AddContributers";
import CreditzType from "./CreditzType";
import Details from "./Details";
import MoreDetails from "./MoreDetails";
import Preview from "./preview";
import { allRoles } from "../../assets/constants";
import Placeholder from "../../assets/images/Placeholder.png";
import { getSpotifyData } from "./addCreditzFuntions";
import { database, storage } from "../../firebase";
import { toast, ToastContainer } from "react-toastify";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";


import {
  firstCreditz,
  forthCreditz,
  secondCreditz,
  thirdCreditz,
} from "./defaultCreditz";
import Message from "../../components/Message";
import { CheckSquareFilled } from "@ant-design/icons";




///////function toast////////////////////////////////
export function toastGenerator( message){
  toast.dismiss(window.toastId);
  window.toastId= toast(` ❌ ${message}`, {
    position: "top-center",
    autoClose: 5000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    style:{color: "black",letterSpacing:"2px", width:'100%', textAlign:'center', border: "2px solid red"}
    });
}


/////////toast ends here /////////////////////////



const AddCreditzSteps = () => {
  const [activeStep, setActiveStep] = useState(1);
  const [category, setCategory] = useState("");
  const [imagelink, SetImageLink] = useState(Placeholder);
  const [imageLinkAudio, setImageLinkAudio] = useState(Placeholder);
  const [imageLinkVideo, setImageLinkVideo] = useState(Placeholder);
  const { currentUser } = useSelector((state) => ({
    currentUser: state.profile.currentUser,
  }));
  const [message, setMessage] = useState(null);
  const [response, SetResponse] = useState([]);
  const [firebaseimagelink, setFirebaseimagelink] = useState("");
  const [previewurl, setPreviewUrl] = useState("");
  const [spotifylink, setSpotifyLink] = useState("");
  const [fields, setFields] = useState([{}, {}, {}, {}]);
  const [creditz, setCreditz] = useState([]);
  const [youtubeSong, setYoutubeSong] = useState("");

  const [music, setMusic] = useState({
    myrole: allRoles[0],
    artistname: "",
    trackname: "",
  });
  const [furthurDetails, setfurthurDetails] = useState({
    releaseDate: "",
    Copyright: "",
  })

  const [selectedRoles, setSelectedRoles] = useState([]);
  const [selectedEmails, setSelectedEmails] = useState([]);
  const [creditz2, setCreditz2] = useState([]);
  const [fields2, setFields2] = useState([]);
  const [youtubeUrl, setYoutubeUrl] = useState("");
  const [videoErrMessage, setVideoErrMessage] = useState('');
  const [videoFieldsErr, setVideoFieldsErr] = useState('');
  const [detailsFieldsErr, setDetailsFieldsErr] = useState('');
  const [contributerFieldsErr, setContributerFieldsErr] = useState('');




console.log('music ',music)

////// using useReducer to manage video comp state step2//////
const videoInitState = {
    videoURL:'',
    videoName:'',
    myRole:allRoles[0],
  }


function reducer(state, action) {
  
  switch (action.type) {
    case 'url':
         return {...state, videoURL: action.payload.url}
    case 'name':
        return {...state, videoName: action.payload.name}
    case 'role':
        return {...state, myRole: action.payload.role}
    default:
      return state
  }
}

const [videoState, setVideoState] = useReducer(reducer, videoInitState )
/////////   Reducer Ends Here //////////////////////////////////

 ////////sleeppp function //////////////////////////////////

 function sleep(ms) {
  return new Promise(
    resolve => setTimeout(resolve, ms)
  );
}

//////////////////////////////////

///// Next step Validation function //////////////////////////////////

async function stepValidator(activeStep){
  let check;

  //// step 1 validations

  if(activeStep===1){
     check = category===""? false : true;
     if(!check){
      
      toastGenerator("Please fill all fields to proceed")

      return check
     }
     return check
  }


  /// step 2 validations

  else if(activeStep===2 && category === "Youtube Video"){
    check= videoState.myRole===""? false:videoState.videoName===""?false:videoState.videoURL?true:false;
    if(!check){
     
      setVideoFieldsErr('Please fill all fields to proceed');
      toastGenerator('Please fill all fields to proceed')
      return false;
    }else{
      setVideoFieldsErr('');
    }
    

    if (videoErrMessage){
      return false;
    }
    return true;
  }
  else if(activeStep===2 && category === "Music"){
    check= music.artistname===""? false: music.trackname===""?false:true;
    if(!check){
      toastGenerator('Please fill all fields to proceed')
      return false;
    }
    
    await sleep(2000);
    if(message){
      return false;
    }

    return check;
  }

     /////step 4 validation 

  else if(activeStep===4){
    let check;
    check  =!furthurDetails.releaseDate?false: !furthurDetails.Copyright?false:true;
    if(!check){
      setDetailsFieldsErr('Please fill all fields to proceed')
      toastGenerator('Please fill all fields to proceed')

      return false
    }else{
      setDetailsFieldsErr('')
      return true
    }

  }
  
  ////// step 3 validations

  else if(activeStep===3){
    let check;
    for (const contributer of creditz) {
    
    

      if(contributer.email===''?true:contributer.role===''?true:false){
        check= false;
        setContributerFieldsErr('Please fill all fields to proceed')
        toastGenerator('Please fill all fields to proceed')

        break;

      }
      else{
        check= true;
        setContributerFieldsErr('')
      }

      
    }
    console.log(check);
    return check?true:false;
  }


}

////////////////////// validator ends here  //////////////////////



//////////// next button handler ///////////////////////////////////
async function nextButtonHandler(){
   console.log(await stepValidator(activeStep));
  if (await stepValidator(activeStep)){
    setActiveStep(activeStep+1)
  }
}


//////////////  next button handler ends here ////////////////////////

  // Third Steps Functions
  function addFields() {
    const creditz = [];
    if(category=== "Music"){
    creditz.push(firstCreditz(0));
    creditz.push(secondCreditz(6));
    creditz.push(thirdCreditz(5));
    creditz.push(forthCreditz(11));
    }else{
    creditz.push(firstCreditz(18));
    creditz.push(secondCreditz(29));
    creditz.push(thirdCreditz(15));
    creditz.push(forthCreditz(19));
    }
    
    setCreditz(creditz);
  }
  useEffect(() => {
    addFields();
  }, [allRoles, category]);

  function handleRemove(i) {
    const values = [...fields];
    values.splice(i, 1);
    setFields(values);
    creditz.splice(i, 1);
  }

  function handleAdd() {
    const blandCreditz = {
      role: "",
      email: "",
      selectedUsername: { value: "", label: "" },
      selectedRole: { value: "", label: "" },
    };
    setCreditz([...creditz, { ...blandCreditz }]);
    const obj = { label: "", value: "" };
    const values = [...fields];
    values.push(obj);
    setSelectedEmails([...selectedEmails, { ...obj }]);
    setFields(values);
    setSelectedRoles([...selectedRoles, obj]);
  }

  function setCredit(newCreditz) {
    setCreditz([...newCreditz]);
  }

  function setCredit2(newCreditz) {
    setCreditz2([...newCreditz]);
  }

  function handleAdd2() {
    const blandCreditz = {
      role: "",
      email: "",
      selectedRole: { value: "", label: "" },
    };

    setCreditz2([...creditz2, { ...blandCreditz }]);
    const obj = { label: "", value: "" };
    const values = [...fields2];
    values.push(obj);
    setFields2(values);
  }
  function handleRemove2(i) {
    const values = [...fields2];
    values.splice(i, 1);
    setFields2(values);
    creditz2.splice(i, 1);
  }
  //Third Step Ends

  //Forth Step Starts
  console.log('furhtir', furthurDetails)

  function setFurthur(type, value) {
    if (type === 'release') {
      setfurthurDetails({

        ...furthurDetails, releaseDate: value
      })
    }
    else {
      setfurthurDetails({

        ...furthurDetails, Copyright: value
      })

    }

  }
  //Forth Step Ends

  async function uploadImage(imagelink) {
    var remoteimageurl = imagelink;
    fetch(remoteimageurl)
      .then((res) => {
        return res.blob();
      })
      .then((blob) => {
        storage
          .ref("creditz_images")
          .child(`/${new Date().getTime()}`)
          .put(blob)
          .then(function (snapshot) {
            return snapshot.ref.getDownloadURL();
          })
          .then((url) => {
            setFirebaseimagelink(url);
            setMessage(null);
          });
      })
      .catch((error) => {
        console.error(error);
      });
  }



  /////// on key press function for Audio step ////////////

 async function onKeyPress() {
    // if (task.category != "Youtube Video") {
    //     getSpotifyData();
    // } else {
    //     getYoutubeData();
    // }
    try{

    
    const data = await getSpotifyData(music.artistname, music.trackname)
    console.log("'''''''''''''''''''''''''",data);
    if(!data){
      throw 'Track or Artist Name is invalid';
    }
    if(data.data.Tracks.tracks.items.length===0){
      throw 'Track or Artist Name is invalid';
    }
    setMessage(null);
    SetResponse(data.data.Tracks.tracks.items[0]);
    setImageLinkAudio(data.data.Tracks.tracks.items[0].album.images[1].url);
    uploadImage(data.data.Tracks.tracks.items[0].album.images[1].url);
    setPreviewUrl(data.data.Tracks.tracks.items[0].preview_url);
    setSpotifyLink(data.data.Tracks.tracks.items[0].external_urls.spotify);
    
  }catch(e){
    setImageLinkAudio(Placeholder);
    setMessage("Artist Name or Track Name is Invalid");
    console.log(e)
  }
      // .then((data) => {
       
      //   setMessage(null);
      //   SetResponse(data.data.Tracks.tracks.items[0]);
      //   setImageLinkAudio(data.data.Tracks.tracks.items[0].album.images[1].url);
      //   uploadImage(data.data.Tracks.tracks.items[0].album.images[1].url);
      //   setPreviewUrl(data.data.Tracks.tracks.items[0].preview_url);
      //   setSpotifyLink(data.data.Tracks.tracks.items[0].external_urls.spotify);
      // })
      // .catch((error) => {
      //   setImageLinkAudio(Placeholder);
      //   setMessage("Artist Name or Track Name is Invalid");
      // });
  }

///////////////////////////////////////////////////////////////


  console.log("firebase", firebaseimagelink);

  function updatemusicState(key, value) {
    if (key === "trackname") {
      setMusic({
        ...music,
        trackname: value,
      });
    } else if (key === "artistname")
      setMusic({
        ...music,
        artistname: value,
      });
    else if (key === "myrole")
      setMusic({
        ...music,
        myrole: value,
      });
  }


  /////////////// function belongs to step 2 video comp that is invoked when url field is blurred////////////////////////////////

  function onBlur() {

    if(youtubeUrl === "") {
      setImageLinkVideo(Placeholder);
      setVideoErrMessage("Please Enter Url")
      return;
    };
    if(!youtubeUrl.includes("=")) {
      setImageLinkVideo(Placeholder);
      setVideoErrMessage("Please Enter full valid URL");
      toastGenerator("Please Enter full valid URL")

      return;
    }
    toast.info("    ℹ️ Searching for data .. ", { autoclose: true });
    if (category === "Youtube Video") {
       getYoutubeData();
    }
  }
  

  let myArr = [];
  let newArr=[];
  let data=[];
  async function getYoutubeData() {

   

    
    
    
    if (youtubeUrl != "") {
      myArr = youtubeUrl.split("=");

    } else {
      myArr[1] = "";
    }
    if(myArr[1].includes("channel")){
      newArr=myArr[1].split("&")
      data=myArr[1].split("&")
      }
      else{
        data.push(myArr[1])
      }
    await axios
      .get(
        `https://us-central1-creditzmusic.cloudfunctions.net/YoutubeApi?id=${data[0]}`
      )
      .then(({ data }) => {
        if (data.length) {
          let image = data[0].snippet.thumbnails.standard.url;
          
          let title = data[0].snippet.title;
          console.log(`Title ${typeof title}`)

          setVideoErrMessage("")
          setImageLinkVideo(image);
          setFirebaseimagelink(image)
          setYoutubeSong(title);
          setVideoState({
            type:'name',
            payload:{
              name: title
            }
          })
        }else{
          throw 'invalid url';
        }
      })
      .catch((error) => {
        setImageLinkVideo(Placeholder);

        setVideoErrMessage('Video URL is invalid');
      });

    
  }


  function updateCategory(value) {
    setCategory(value);
  }

  

  function getStepContent(step) {
    switch (step) {
      case 1:
        return <CreditzType updateCategory={updateCategory} />;
      case 2:
        return (
          <Details
            category={category}
            allRoles={allRoles}
            imageLinkAudio={imageLinkAudio}
            imageLinkVideo={imageLinkVideo}
            updatemusicState={updatemusicState}
            music={music}
            onKeyPress={onKeyPress}
            youtubeUrl={youtubeUrl}
            setYoutubeUrl={setYoutubeUrl}
            onBlur={onBlur}
            message={message}
            videoErrMessage={videoErrMessage}
            youtubeSong={youtubeSong}
            setYoutubeSong={setYoutubeSong}
            videoState={videoState}
            setVideoState={setVideoState}
            videoFieldsErr={videoFieldsErr}
          />
        );
      case 3:
        return (
          <AddContributers
            fields={fields}
            creditz={creditz}
            handleRemove={handleRemove}
            handleAdd={handleAdd}
            selectedRoles={selectedRoles}
            selectedEmails={selectedEmails}
            setCredit={setCredit}
            setCredit2={setCredit2}
            fields2={fields2}
            creditz2={creditz2}
            handleRemove2={handleRemove2}
            handleAdd2={handleAdd2}
            contributerFieldsErr={contributerFieldsErr}
          />
        );
      case 4:
        return <MoreDetails setFurthur={setFurthur} furthurDetails={furthurDetails} detailsFieldsErr={detailsFieldsErr}/>;  
      case 5:
        return <Preview music={ category==='Youtube Video'? videoState:music}    
        creditz={creditz} 
        creditz2={creditz2} 
        furthurDetails={furthurDetails}
        category={category}
        />
      default:
        throw new Error("Unknown step");
    }
  }



  //Publish Function 
  async function Publish() {
      let types = "";
      if (category === "Music") {
        types = "Spotify";
      } else {
        types = "Youtube";
      }
      let preview = "";
      let spotify = "";
      let youtubesong = "";
      let directornames = "";
      if (previewurl && category != "Youtube Video") {
        preview = previewurl;
      } else if (category === "Youtube Video") {
        preview = youtubeUrl;
      }
      if (spotifylink) {
        spotify = spotifylink;
      } else {
        spotify = "";
      }
      if (category === "Youtube Video") {
        youtubesong = youtubeSong;
        // directornames = directorname;
      } else {
        youtubesong = "";
        directornames = "";
      }
       let split=[];
      let data=[];
      if (youtubeUrl != "") {
        split = youtubeUrl.split("=");
      } else {
        split[1] = "";
      }
      if(split[1].includes("channel")){
        data=split[1].split("&")
        }
        else{
          data.push(split[1])
        }
      

      return database
        .ref("creditz/")
        .push({
          category: category,
          artistname: music.artistname,
          trackname: music.trackname,
          role: music.myrole,
          uid: currentUser.uid,
          albumImage: firebaseimagelink,
          publishedAt: moment().toDate().getTime(),
          publishedBy: currentUser.firstName + "" + currentUser.lastName,
          type: types,
          previewurl: preview,
          spotifylink: spotify,
          username: currentUser.username,
          youtubetitle: youtubesong,
          directorname: directornames,
          youtubevideoid:data[0],
          releaseDate:furthurDetails.releaseDate,
          CopyrightOwner:furthurDetails.Copyright
        })
        .then((pushed_user) => {
          creditz.map((email) => {
            return database.ref("user-creditz/" + pushed_user.key).push({
              email: email.email,
              status: "Pending ",
              credid: pushed_user.key,
              role: email.role,
              username: email.username,
            });
          });
          creditz2.map((email) => {
            database.ref("user-creditz/" + pushed_user.key).push({
              email: email.email,
              status: "Pending ",
              credid: pushed_user.key,
              role: email.role,
            });
            const config = {
              headers: {
                "Access-Control-Allow-Headers": "privatekey",
              },
            };
            axios.post(
              `https://us-central1-creditzmusic.cloudfunctions.net/sendMail?dest=${email.email}`,
              {
                email: currentUser.email,
                title: music.trackname,
              },
              config
            );
          });
          notifications(pushed_user.key);
          setMusic({
            ...music,
            artistname: "",
            trackname: "",
          });
          setFirebaseimagelink("");
          SetImageLink(Placeholder);
          setYoutubeUrl("")
          setFields([]);
          toast.success("Your Creditz is now Published 🎤 ", {
            autoclose: true,
          });
          setCreditz([]);
         
        });
    
  }
  function notifications(key) {
    creditz.map((email) => {
      return database.ref("Notifications/").child(email.uid).child(key).set({
        sender: currentUser.uid,
        status: "Pending",
        credid: key,
        type: "Creditz",
        timestamp: moment().toDate().getTime(),
        isDeleted: "false",
      });
    });
  }
// Publish function ends

  // useEffect(() => {
  //   getStepContent(activeStep);
  // }, [activeStep]);

  console.log(activeStep);
  console.log("creddddd", creditz);
  return (
    <>
      <AsideNewFeed></AsideNewFeed>

      <section className="main-content ">
        <div className="middle-box">
          <div className="row">
            <div className="col-sm-12 mb-5">
              <div className="card border-0 rounded-xl shadow-xs overflow-hidden mb-3">
                <div className="card-header d-flex align-items-center bg-primary px-4 py-2 fw-bold text-white">
                  {" "}
                  <Link
                    to="/Creditz"
                    className="d-inline-flex align-middle text-white py-3 pe-4"
                  >
                    <svg className="icon icon-8x" >
                      <use href="#icon_arrowback"></use>
                    </svg>
                  </Link>
                  Add Creditz
                  <h5 className="btn btn-primary fw-medium rounded-pill px-3 ms-auto">
                    {activeStep + "/5"}
                  </h5>
                </div>{" "}
              </div>
            </div>
          </div>
          {getStepContent(activeStep)}
          <br></br>

          <div className="col-sm-12 mb-5">
            <div className="card border-0 rounded-xl shadow-xs overflow-hidden mb-3">
              <div className="card-header d-flex align-items-center  px-4 py-2 fw-bold text-white" style={{ backgroundColor: "white"}}>
             
                  {activeStep>1?(<button
                    className="btn btn-secondary  fw-semibold px-3"
                    style={{marginTop:'8px', marginBottom:'8px', marginRight:'8px', borderRadius:'10px', width:'150px'}}

                    onClick={() => setActiveStep(activeStep - 1)}
                  >
                    Back
                  </button>):""}
                  {activeStep==5?  <button
                  className="btn btn-primary fw-medium  px-3 ms-auto"
                  style={{marginTop:'8px', marginBottom:'8px', marginRight:'8px', borderRadius:'10px', width:'150px'}}
                  onClick={()=>Publish()}
                >
                  Publish
                </button>:<button
                  className="btn btn-primary fw-medium  px-3 ms-auto"
                  style={{marginTop:'8px', marginBottom:'8px', marginRight:'8px', borderRadius:'10px', width:'150px'}}
                  onClick={nextButtonHandler}
                >
                  Next
                </button>}
             
                


              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AddCreditzSteps;
